<template>
  <div :class="['header', { 'simple-header': status == 'simple' }]">
    <div class="logo">
      <div class="logo-img"></div>
      <div class="name">智慧旅游大数据监管平台</div>
    </div>
    <ul class="router" v-if="!status">
      <li
        :class="{ current: activeIndex == index }"
        :key="index"
        @click="goPage(item.href)"
        v-for="(item, index) in routeList"
      >
        {{ item.name }}
        <div class="child" v-if="item.child">
          <div
            :key="index2"
            @click="goPage(item2.href)"
            v-for="(item2, index2) in item.child"
          >
            {{ item2.name }}
          </div>
        </div>
      </li>
    </ul>
    <div class="menu">
      <ul>
        <li @click="$store.commit('setSpotModalShow')">
          <div class="icon">
            <img src="../../assets/header_menu/spot.png" />
          </div>
          <div class="text">景区选择</div>
          <div class="arrow"></div>
        </li>
        <li @click="dateBoxShow = true" class="data-select">
          <div class="icon">
            <img src="../../assets/header_menu/time.png" />
          </div>
          <div class="text">时间</div>
          <div class="arrow"></div>
        </li>
        <!-- <li @click="goMenu">
          <div class="icon">
            <img src="../../assets/header_menu/chart.png" />
          </div>
          <div class="text">{{ $store.state.curPageName }}</div>
          <div class="arrow"></div>
        </li>-->
        <li @click="fullScreen" class="full">
          <img
            src="../../assets/header_menu/full_close.png"
            v-if="$store.state.fullscreen"
          />
          <img
            src="../../assets/header_menu/full.png"
            v-if="!$store.state.fullscreen"
          />
        </li>
        <li class="user">
          <img src="../../assets/header_menu/user.png" />
        </li>
      </ul>
    </div>

    <div class="date-box" v-if="dateBoxShow" @mouseleave="dateBoxShow = false">
      <Datepicker v-on:postTime="getTime" />
    </div>
  </div>
</template>

<script>
import Datepicker from "@/components/Common/Datepicker_sp.vue";

export default {
  name: "Header",
  components: {
    Datepicker
  },
  props: {
    status: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      dateBoxShow: false,
      routeList: [
        {
          name: "客情洞察",
          href: "/"
        },
        // {
        //   name: "出游客情",
        //   href: "/juminchuyou"
        // },
        // {
        //   name: "口碑&舆论",
        //   child: [
        //     {
        //       name: "口碑评价",
        //       href: "/jingqukoubei"
        //     },
        //     {
        //       name: "旅游舆论",
        //       href: "/lvyouyulun"
        //     }
        //   ]
        // },
        {
          name: "资源评估",
          href: "/ziyuanpinggu"
        }
        // {
        //   name: "全域旅游",
        //   href: 0
        // },
        // {
        //   name: "主题游",
        //   child: [
        //     {
        //       name: "夜间游",
        //       href: 0
        //     },
        //     {
        //       name: "乡村游",
        //       href: 0
        //     }
        //   ]
        // }
      ],
      activeIndex: -1
    };
  },
  mounted() {
    // 菜单高亮
    console.log(this.$route.path);
    for (let i = 0; i < this.routeList.length; i++) {
      if (this.$route.path == this.routeList[i].href) {
        this.activeIndex = i;
      } else if (this.routeList[i].child) {
        for (let j = 0; j < this.routeList[i].child.length; j++) {
          if (this.$route.path == this.routeList[i].child[j].href) {
            this.activeIndex = i;
            break;
          }
        }
      }
    }
  },
  methods: {
    fullScreen() {
      let element = document.documentElement;
      if (this.$store.state.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      this.$store.commit("setFullscreen");
    },
    goMenu() {
      this.$router.push({ path: "/menu" });
    },
    goPage(url) {
      if (url == 0) {
        this.$toast("正在建设中...")
        return;
      }
      if (!url) {
        return;
      }
      this.$router.push({ path: url });
    },
    getTime(time) {
      this.dateBoxShow = false;
      console.log(time);
    }
  },
  watch: {
    $route() {
      this.$store.commit("setChildModalShow", false);
      // this.$store.commit("setChildModalCode", -1);
    }
  }
};
</script>

<style scoped lang="less">
.header {
  width: 100%;
  height: 0.64rem;
  background: #040e1a;
  box-shadow: 0px -0.16rem 0.24rem -0.06rem rgba(6, 60, 106, 0.9) inset;
  position: relative;
  z-index: 10000;
  img {
    display: block;
    width: 100%;
    height: 100%;
  }
  > div {
    height: 100%;
  }
  .router {
    width: 7.2rem;
    height: 100%;
    position: absolute;
    top: 0;
    left: 50%;
    margin-left: -3.6rem;
    > li {
      width: 1.2rem;
      height: 100%;
      line-height: 0.64rem;
      float: left;
      position: relative;
      cursor: pointer;
      .child {
        width: 100%;
        position: absolute;
        top: 0.64rem;
        left: 0;
        display: none;
        > div {
          width: 100%;
          height: 0.32rem;
          line-height: 0.32rem;
          background: #032f4f;
          border: 1px solid #0b689c;
        }
      }
    }
    > li:hover {
      .child {
        display: block;
      }
    }
    .current {
      color: @light-blue;
      background: url(../../assets/router_bg.png) repeat-x;
      background-size: contain;
      border-bottom: 1px solid @light-blue;
    }
  }
}
.logo {
  width: 5rem;
  height: 100%;
  background: url(../../assets/logo-bg.png);
  background-size: 100% 100%;
  float: left;
  // font-size: 0.26rem;
  font-size: 0.3rem;
  font-weight: bold;
  color: #fff;
  text-align: left;
  > div {
    float: left;
  }
  .logo-img {
    // width: 1.24rem;
    // height: 0.4rem;
    // margin: 0.1rem 0.12rem 0;
    width: 0.4rem;
    height: 0.52rem;
    margin: 0.05rem 0.18rem 0 0.26rem;
    background: url(../../assets/logo2.png);
    background-size: 100% 100%;
  }
  .name {
    line-height: 0.72rem;
    height: 100%;
  }
}
.menu {
  width: 4.5rem;
  float: right;
  height: 100%;
  > ul {
    height: 100%;
    float: right;
    padding-right: 0.24rem;
    box-sizing: border-box;
    .full,
    .user {
      height: 0.3rem;
      width: 0.3rem;
      margin-top: 0.18rem;
    }
    > li {
      height: 0.64rem;
      line-height: 0.66rem;
      float: left;
      color: @base-text-color;
      margin-left: 0.28rem;
      cursor: pointer;
      > div {
        float: left;
      }
      .icon {
        width: 0.3rem;
        height: 0.3rem;
        margin-right: 0.04rem;
        margin-top: 0.17rem;
      }
      .arrow {
        width: 0.3rem;
        height: 0.3rem;
        background: url(../../assets/header_menu/arrow.png);
        background-size: 100% 100%;
        margin-top: 0.18rem;
      }
    }
  }
}
.simple-header {
  background: none;
  box-shadow: none;
  .menu {
    display: none;
  }
}

.date-box {
  width: 300px;
  position: absolute;
  right: 0rem;
  top: 0.64rem;
}
</style>
